export default {
  "root": "_root_1psb7_1"
};import "ni:sha-256;Jk6C9LnHOSN9Hizx1U8-vnjQYuRcCx4xA1vLevXvgv8";